import { Injectable } from '@angular/core';
import { global } from '../../shared/global';
import { HttpClient,HttpHeaders } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class ConstructionDetailService {

    constructor(private http: HttpClient) { }
    public httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };
    
    getConstructionDetailList(data) {
        this.httpOptions = {
            headers: new HttpHeaders({
                'UserID': localStorage.getItem("userID"),
                'ComponentName': "constructiondetail",
                'Operation': "list",
            })
        }
        return this.http.post(global.baseAPIUrl + 'ConstructionDetail/getConstructionDetailList', data, this.httpOptions);
    }

    deleteConstructionDetail(data) {
        this.httpOptions = {
            headers: new HttpHeaders({
                'UserID': localStorage.getItem("userID"),
                'ComponentName': "constructiondetail",
                'Operation': "delete",
            })
        }
        return this.http.post(global.baseAPIUrl + 'ConstructionDetail/deleteConstructionDetail', data, this.httpOptions);
    }
}